import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(redirects)/placesmap')({
  loader: () => {
    throw redirect({ to: '/place/map', statusCode: StatusCodes.MOVED_PERMANENTLY })
  },
})
